import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AdminContext } from "../Contexts/AdminContext";

const ProtectedRoute = ({ children }) => {
  const { admin, getAdmin, loading } = useContext(AdminContext);
  const navigate = useNavigate();
  useEffect(() => {
    getAdmin();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!admin) {
    return navigate("/sawa-admin-login");
  }

  return children;
};

export default ProtectedRoute;
